module.exports = __webpack_public_path__ + "static/media/SufiHakim.2fe3dff8.jpeg";